import * as Select from '@studio/design-system/select';
import { useLatestFn, useLazyRef } from '@studio/react-utils/hooks';
import { toBoolean } from '@tryiris-ai/js-types';
import type { ReactElement } from 'react';
import type { Props } from './types.js';

/** `<Parity>` component. */
export const Parity = ({ parity, size, ...props }: Props): ReactElement => {
  const handleValueChange = useLatestFn((nextValue: string) => {
    const nextParity = toBoolean(nextValue);

    if (nextParity !== parity.value) {
      parity(nextParity);
    }
  });

  return (
    <Select.Root onValueChange={handleValueChange} size={size} value={parity.value ? '1' : '0'}>
      <Select.Trigger {...props}>
        <Select.Value />
      </Select.Trigger>

      <Select.Content>
        {
          useLazyRef(() => [
            <Select.Item key='1' value='1'>
              Parity
            </Select.Item>,
            <Select.Item key='0' value='0'>
              No Parity
            </Select.Item>
          ]).current
        }
      </Select.Content>
    </Select.Root>
  );
};
